export const Separator = () => (
  <div className="after:bg-sidebar-border relative after:absolute after:top-1/2 after:left-[5%] after:block after:h-px after:w-[90%] after:content-['']" />
);
